// @ts-check
import { initSchema } from '@aws-amplify/datastore';
import { schema } from './schema';

const PaymentMethod = {
  "POINT": "POINT",
  "PAYPAY": "PAYPAY",
  "CASH": "CASH"
};

const { WorkHistory, PointHistory, TimeTable, Course, Member, MemberType, Machine, Shop, User, Group, RegistrationCode, TabletErrorLog, SmartLock, MachineSession, PointListType } = initSchema(schema);

export {
  WorkHistory,
  PointHistory,
  TimeTable,
  Course,
  Member,
  MemberType,
  Machine,
  Shop,
  User,
  Group,
  RegistrationCode,
  TabletErrorLog,
  SmartLock,
  MachineSession,
  PaymentMethod,
  PointListType
};